import useManageApi from "../../hooks/useManageApi";
import { UserContext } from "../../store/user-context";
import { useContext, useEffect, useState } from "react";

const AdminView = (props) => {

    const { userInfo, setUserInfo } = useContext(UserContext);
    const [userInfoTracker, setUserInfoTracker] = useState(null);
    const {loadId, exitAdminView} = useManageApi();

    useEffect(()=>{
        loadId().then((result) => setUserInfo(result?.data));
    },[]);

    useEffect(()=>{
        setUserInfoTracker(userInfo);
    },[userInfo]);

    function removeAdminView(){
        exitAdminView().then(()=>
            {window.location.href = process.env.REACT_APP_PUBLIC_URL;}
        );
    }

    return (
        <>
            {userInfoTracker !== null && userInfoTracker?.userId && <div className="mb-3">
                <div className="alert-primary alert">
                    <div><h5>Welcome to Admin View!</h5>
                        You are currently viewing user: <span className="fw-bold">{userInfoTracker?.firstName} {userInfoTracker?.lastName}</span>
                    </div>
                    <div className="btn-container justify-content-end d-flex mt-3">
                        <button className="btn btn-primary" onClick={removeAdminView}>Exit Admin View</button>
                    </div>
                   
                </div>
            </div>}
            {props.children}
        </>
    );
}

export default AdminView;